module.exports = __webpack_public_path__ + "assets/img/taobao.b5c779b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav/taobao.png
// module id = s+b9
// module chunks = 1